import { Injectable } from '@angular/core';
import { api } from "@bayclubs/utils";
import * as fileSaver from 'file-saver';
import { Observable } from 'rxjs';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { camps } from '../../models/models.generated';



@Injectable()
export class RosterApiService {

    constructor(private http: ApiHttpClient) { }

    public search(request: camps.RosterRequest): Observable<api.OperationResultValue<camps.RosterInfoModel>> {
        return this.http.post<api.OperationResultValue<camps.RosterInfoModel>>("roster/search", request, false);
    }

    public getProfile(request: camps.RosterRequest, clubCode: string) {
        this.http.postFileRequest('roster/profiles',request)
            .subscribe((responseSuccess: any) => {

                var blob = new Blob([responseSuccess], { type: 'application/pdf' });
                fileSaver.saveAs(blob, `RosterProfiles_${clubCode}_${request.dateFrom.value}_${request.dateTo.value}.pdf`);

            }, (error) => {
                console.log(error);
               // this.alert.showError("File not found.")
            });
    }


    public getSummary(request: camps.RosterRequest, clubCode: string) {
        this.http.postFileRequest('roster/summary',request)
            .subscribe((responseSuccess: any) => {

                var blob = new Blob([responseSuccess], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `RosterSummary_${clubCode}_${request.dateFrom.value}_${request.dateTo.value}.xlsx`);

            }, () => {
               // this.alert.showError("File not found.")
            });
    }
}
